const checkoutConstraints = Object.freeze({
  pattern: {
    discountCode: /^[a-zåäöA-ZÅÄÖ!0-9_.-\s]*$/,
    tipValue: /^\d+(\.\d{1,2})?\s*$/,
  },
  min: {
    discountCode: 4,
  },
  max: {
    discountCode: 10,
    instructions: 200,
    tipValue: 10000,
  },
})

export default checkoutConstraints
